import { ShieldCheck, Landmark, Banknote, Train, MapPin, GraduationCap, Crosshair, BookOpen, Award } from "lucide-react";
export const EXAM_ICONS = { ShieldCheck, Landmark, Banknote, Train, MapPin, GraduationCap, Crosshair, BookOpen };
export const examIcon = (name) => EXAM_ICONS[name] || Award;
